"use strict";import{html as i}from"@cisco-u/base";export function aiLogoSmall({height:t="100%",width:e=40,hidden:a=!1,title:o=""}={}){return i`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${e}
    height=${t}
    viewBox="0 0 40 40"
    fill="none"
    aria-hidden="${a?"true":"false"}"
    aria-label="${o}"
  >
    <path
      d="M29.375 17.5C34.5527 17.5 38.75 21.6973 38.75 26.875C38.75 32.0527 34.5527 36.25 29.375 36.25C24.1973 36.25 20 32.0527 20 26.875C20 21.6973 24.1973 17.5 29.375 17.5Z"
      fill="url(#paint0_linear_479_24383)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 29.4713C14.7648 29.4713 10.5208 25.2286 10.5208 19.9949C10.5208 14.7612 14.7648 10.5185 20 10.5185C25.2352 10.5185 29.4792 14.7612 29.4792 19.9949C29.4792 25.2286 25.2352 29.4713 20 29.4713ZM3.75 19.9949C3.75 28.967 11.0254 36.2402 20 36.2402C28.9746 36.2402 36.25 28.967 36.25 19.9949C36.25 11.0229 28.9746 3.74958 20 3.74958C11.0254 3.74958 3.75 11.0229 3.75 19.9949Z"
      fill="url(#paint1_linear_479_24383)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.2408 20.494C34.5294 18.6582 32.0897 17.5102 29.3819 17.5102C29.3036 17.5102 29.2256 17.5111 29.1478 17.513C29.3638 18.3072 29.479 19.1428 29.479 20.0054C29.479 25.1163 25.4329 29.2822 20.3691 29.4749C21.1137 32.0709 22.9496 34.2056 25.3485 35.3506C31.5482 33.191 36.0373 27.3804 36.2408 20.494Z"
      fill="url(#paint2_linear_479_24383)"
    />
    <path
      d="M29.3711 17.5C34.5488 17.5 38.7461 21.6973 38.7461 26.875C38.7461 32.0527 34.5488 36.25 29.3711 36.25C24.1934 36.25 19.9961 32.0527 19.9961 26.875C19.9961 21.6973 24.1934 17.5 29.3711 17.5Z"
      fill="url(#paint3_radial_479_24383)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_479_24383"
        x1="20.3718"
        y1="36.25"
        x2="35.7237"
        y2="20.8981"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0087EA" />
        <stop offset="1" stop-color="#63FFF7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_479_24383"
        x1="36.25"
        y1="36.2402"
        x2="3.75935"
        y2="3.74024"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0051AF" />
        <stop offset="0.666238" stop-color="#0087EA" />
        <stop offset="1" stop-color="#00BCEB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_479_24383"
        x1="26.181"
        y1="30.0129"
        x2="34.8721"
        y2="19.9608"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#74BF4B" stop-opacity="0" />
        <stop offset="1" stop-color="#74BF4B" />
      </linearGradient>
      <radialGradient
        id="paint3_radial_479_24383"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(38.7461 17.5) rotate(135) scale(26.5165 26.5053)"
      >
        <stop stop-color="#00BCEB" stop-opacity="0" />
        <stop offset="0.666962" stop-color="#00BCEB" stop-opacity="0" />
        <stop offset="1" stop-color="#00BCEB" />
      </radialGradient>
    </defs>
  </svg>`}
//# sourceMappingURL=ai-logo-small.js.map
